import { createVNode as n, mergeProps as m } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/WordTwoTone.js";
import a from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(a, m(t, {
    icon: s
  }), null);
};
o.displayName = "WordTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
